import type { PmConsumable } from "../../../domain/ndt/pm-consumable.js";
import type { PmConsumableRepository } from "../../../repositories/operational-repositories.js";

const STORAGE_KEY = "pm_consumables";

export class InMemoryPmConsumableRepository implements PmConsumableRepository {
  private items = new Map<string, PmConsumable>();

  constructor() {
    this.loadFromStorage();
  }

  private loadFromStorage() {
    try {
      if (typeof localStorage !== "undefined") {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
          const parsed: PmConsumable[] = JSON.parse(stored);
          for (const item of parsed) this.items.set(item.id, item);
        }
      }
    } catch (e) {
      console.warn("Failed to load PM consumables from storage:", e);
    }
  }

  private persistStorage() {
    try {
      if (typeof localStorage !== "undefined") {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(this.items.values())));
      }
    } catch (e) {
      console.warn("Failed to persist PM consumables to storage:", e);
    }
  }

  async findById(id: string): Promise<PmConsumable | null> {
    this.loadFromStorage();
    return this.items.get(id) || null;
  }

  async listAll(): Promise<readonly PmConsumable[]> {
    this.loadFromStorage();
    return Array.from(this.items.values());
  }

  async save(item: PmConsumable): Promise<void> {
    this.items.set(item.id, { ...item });
    this.persistStorage();
  }

  async delete(id: string): Promise<void> {
    this.items.delete(id);
    this.persistStorage();
  }
}
